export function setTestimonials (state, { testimonials }) {
  state.testimonials = testimonials || []
}
